/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { PriceResponse, PriceState } from './types';
import { getDefaultErrorState, getDefaultLoadingState } from '@a/store/utils';
import { MutationRequestStatus } from '@a/store/types';

export const mutations: MutationTree<PriceState> = {
  priceLoading(state) {
    state.productPrice = { ...getDefaultLoadingState() };
  },
  priceLoaded(state, payload: PriceResponse) {
    state.productPrice = {
      status: MutationRequestStatus.SUCCESS,
      data: payload,
      error: undefined,
    };
  },
  priceFailure(state) {
    state.productPrice = { ...getDefaultErrorState() };
  },
};
